"use client";

import {useEffect,useState} from 'react'
import {Types}  from '../../context/globalStateContext/types'
import  Modal  from './index';
import LoginWithMobile from 'components/Modals/LoginModal';
import { useModalState, useModalDispatch } from 'src/context/globalStateContext/provider'

const GlobalModalComponent = () => {
  const { modalName, isShowing, actionType } = useModalState();
  const [pageName, setPageName] = useState("");
  const dispatch = useModalDispatch();
  useEffect(() => {
    if (!isShowing) {
      setPageName("");
    } else setPageName(modalName);
  }, [modalName, isShowing]);
  const onClose = () => {
    dispatch({ type: actionType });
  };

  const renderPage = () => {
    switch (pageName) {
      case Types.LOGIN_MODAL:
        return <LoginWithMobile />;
      default:
        return null;
    }
  };

  return (
    <>{isShowing ? <Modal onClose={onClose}>{renderPage()}</Modal> : null}</>
  );
};
export default GlobalModalComponent;
